import { apiClient } from './client';
import type { GitHubDashboardSummary, GitHubRepo } from '../types';

export const githubApi = {
  async getSummary(): Promise<GitHubDashboardSummary> {
    const { data } = await apiClient.get<GitHubDashboardSummary>('/github/summary');
    return data;
  },
  async getRepos(): Promise<GitHubRepo[]> {
    const { data } = await apiClient.get<{ repos: GitHubRepo[] }>('/github/repos');
    return data.repos;
  },
};
